import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'

import sizes from '../foundations/sizes'

const helpers = createMultiStyleConfigHelpers(['heading', 'cell'])
const CalendarTheme = helpers.defineMultiStyleConfig({
  baseStyle: {
    heading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: sizes['3xs'],
      alignSelf: 'stretch',
      padding: sizes['5xs'],
    },
    cell: {},
  },
})

export default CalendarTheme
